import { defineMessages, useIntl } from 'react-intl';
import { Flag } from '@packages/shared/src/ui/Flag/Flag';
import { HintPanel } from '../HintPanel/HintPanel';

const messages = defineMessages({
  Co2CompensationFlagStandard: {
    id: 'Co2CompensationFlag.standard',
    defaultMessage: '{flag} durch Kompensation',
  },
  Co2CompensationFlagHint: {
    id: 'Co2CompensationFlag.hint',
    defaultMessage: 'Co2-neutral',
  },
});

export const Co2CompensationFlag: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <HintPanel className="text-size-body-sm p-1.5 text-left">
      {formatMessage(messages.Co2CompensationFlagStandard, {
        flag: (
          <Flag variant="sustainability" text={formatMessage(messages.Co2CompensationFlagHint)} />
        ),
      })}
    </HintPanel>
  );
};
